<template>
	<div class="gallery-container">
		<div :class="`${gallery.view}-gallery-preview`">
			<div v-for="(gItem, index) in gallery.fields.data" :key="index" class="gallery-item-small" :style="`background-image: url(/api/resized-media/${gItem});`"
			@click="openFullScreen(gItem);">
				<img :src="`/api/resized-media/${gItem}`" />
			</div>
		</div>
		<div class="gallery-view" v-if="fullScreen" @click="closeFullScreen($event)">
			<!-- <div class="gallery-preview gallery-preview-full">
				<div v-for="(gItem, index) in gallery.fields.data" :key="index" class="gallery-item-small" :style="`background-image: url(/storage/media/${findInMedia(gItem).original_name});`"
				@click="openFullScreen(gItem);">
				</div>
			</div> -->
			<div class="gallery-view-full">
				<fa-icon :icon="'times'" class="faicon faicon-close-fullscreen" @click="closeFullScreen($event)" />
				<fa-icon :icon="'angle-left'" class="faicon faicon-left" size="lg" @click="changeImageIndex($event, -1)" v-show="canGoLeft"/>
				<img :src="`/storage/media/${findInMedia(selectedImageId).original_name}`" />
				<fa-icon :icon="'angle-right'" class="faicon faicon-right" size="lg" @click="changeImageIndex($event, 1)" v-show="canGoRight"/>
			</div>
			<!-- <div class="gallery-view-description">
				{{JSON.parse(findInMedia(selectedImageId).description)[language]}}
			</div> -->
		</div>
	</div>
</template>

<script>
import contentDataLoader from '@/store/modules/contentData/content-data-loader';
import staticDataLoader from '@/store/modules/staticData/static-data-loader';
import featureSetLoaderMixin from '@/store/modules/featureSet/feature-set-loader';
import { mapActions } from 'vuex';

export default {
	mixins: [contentDataLoader, staticDataLoader, featureSetLoaderMixin],
	props: {
		gid: {
			type: [String, Number],
			validator(value) {
				return Number.isInteger(Number(value));
			},
		},
	},
	data() {
		return {
			gallery: null,
			selectedImageId: null,
			fullScreen: false,
		};
	},
	created() {
		this.gallery = this.getContent('galleries').find(e => e.id === Number(this.gid));
	},
	computed: {
		imagesInGallery() {
			return this.gallery.fields.data.length;
		},
		canGoLeft() {
			return this.gallery.fields.data.indexOf(this.selectedImageId) > 0;
		},
		canGoRight() {
			return this.gallery.fields.data.indexOf(this.selectedImageId) < this.imagesInGallery - 1;
		},
	},
	methods: {
		...mapActions('gallery', ['setSelectedImage', 'setGallery']),
		openFullScreen(id) {
			if (this.featureSet.gallery.separateFullGalleryView) {
				this.setGallery(this.gallery);
				this.setSelectedImage(id);
			} else {
				this.selectedImageId = id;
				this.fullScreen = true;
			}
		},
		closeFullScreen(e) {
			if (typeof e.target.className === 'string' && e.target.className.includes('gallery-view')) {
				this.fullScreen = false;
			} else if (e.target.classList.contains('faicon-close-fullscreen') || e.target.parentNode.classList.contains('faicon-close-fullscreen')) {
				this.fullScreen = false;
			}
		},
		changeImageIndex(e, modifier) {
			e.preventDefault();
			e.stopPropagation();
			const currentIdx = this.gallery.fields.data.indexOf(this.selectedImageId);
			let newImageIdx = currentIdx + modifier;
			if (newImageIdx < 0) {
				newImageIdx = 0;
			} else if (newImageIdx > this.imagesInGallery - 1) {
				newImageIdx = this.imagesInGallery - 1;
			}
			this.selectedImageId = this.gallery.fields.data[newImageIdx];
		},
	},
};
</script>

<style src="@/styles/components/GalleryView/GalleryView.less" lang="less" scoped></style>
